/*
 * CARVERHAUS: "Open one row at a time" for Horizon accordions.
 * When a row opens inside an accordion marked [data-ch-exclusive], the other open
 * rows of that accordion close. `toggle` does not bubble, so it is caught on capture.
 */
if (!window.chAccordionExclusive) {
  window.chAccordionExclusive = true;
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      const group = details.closest('[data-ch-exclusive]');
      if (!group) return;
      for (const other of group.querySelectorAll('details[open]')) {
        if (other !== details && other.closest('[data-ch-exclusive]') === group) other.open = false;
      }
    },
    true
  );
}
